
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthServiceService } from '../services/auth-service/auth-service.service';
import { HOME_ROUTE } from '../../app-route-paths';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const oauth = inject(OAuthService);
  const authService = inject(AuthServiceService);
  const router = inject(Router);

  if (oauth.getAccessToken() && !authService.iamOnlyUser()) {
    return true;
  }

  if (authService.iamOnlyUser()) {
    return router.parseUrl('/register');
  }

  return router.parseUrl(HOME_ROUTE);
};
